import { Phone, Star, Clock, MapPin, UtensilsCrossed } from "lucide-react";
import { restaurant, images } from "../data";

function isOpenNow() {
  const now = new Date();
  const day = now.getDay(); // 0 Sun ... 6 Sat
  const h = now.getHours();
  // Sat(6)/Sun(0) open 11:00, Mon–Fri open 10:00; close 22:00 daily
  const openH = day === 0 || day === 6 ? 11 : 10;
  const closeH = 22;
  return h >= openH && h < closeH;
}

export default function Hero() {
  const open = isOpenNow();
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-[100svh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img src={images.hero} alt="Steinofen Pizza" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0f0f0f] via-transparent to-black/50" />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl w-full px-6 md:px-10 pt-28 pb-16">
        <img
          src={images.logo}
          alt="Zum Goldenen Döner & Pizza Haus"
          data-testid="hero-logo"
          className="hidden xl:block absolute right-10 top-1/2 -translate-y-1/2 h-[26rem] w-[26rem] rounded-full object-cover ring-2 ring-[#eab308]/30 shadow-2xl shadow-black/60"
        />
        <div className="max-w-3xl">
          <img
            src={images.logo}
            alt="Zum Goldenen Döner & Pizza Haus"
            data-testid="hero-logo-mobile"
            width="176"
            height="176"
            className="xl:hidden mb-6 h-32 w-32 sm:h-44 sm:w-44 rounded-full object-cover ring-2 ring-[#eab308]/30 shadow-2xl shadow-black/60"
          />
          <div
            data-testid="open-status-badge"
            className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 backdrop-blur-md px-4 py-2 text-sm"
          >
            <span className={`h-2.5 w-2.5 rounded-full ${open ? "bg-green-400" : "bg-red-400"} animate-pulse`} />
            <span className="font-medium text-[#f5f5f0]">
              {open ? "Jetzt geöffnet" : "Aktuell geschlossen"}
            </span>
            <span className="text-[#a3a3a3]">· schließt um 22:00 Uhr</span>
          </div>

          <h1 className="mt-6 font-display font-black text-[#f5f5f0] leading-[0.92] text-5xl sm:text-6xl md:text-7xl">
            Zum Goldenen <span className="text-[#e05d36]">Döner</span>
            <span className="block text-3xl sm:text-4xl md:text-5xl text-[#eab308] mt-2">
              & Pizza Haus
            </span>
          </h1>

          <p className="mt-6 text-lg md:text-xl text-[#d4d4cf] max-w-xl leading-relaxed">
            {restaurant.tagline}. Mitten in Krefeld – ehrliches Handwerk,
            frische Zutaten und der Geschmack, der satt & glücklich macht.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-4">
            <a
              href={restaurant.phoneHref}
              data-testid="hero-call-btn"
              className="inline-flex items-center gap-2 rounded-full bg-[#e05d36] hover:bg-[#c94925] text-black font-bold px-7 py-4 transition-[transform,background-color] duration-200 hover:-translate-y-1"
            >
              <Phone size={20} strokeWidth={2.5} />
              {restaurant.phone}
            </a>
            <a
              href="#menu"
              data-testid="hero-menu-btn"
              className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 backdrop-blur-md hover:bg-white/10 text-[#f5f5f0] font-semibold px-7 py-4 transition-colors duration-200"
            >
              <UtensilsCrossed size={20} />
              Speisekarte
            </a>
          </div>

          <div className="mt-12 flex flex-wrap items-center gap-x-10 gap-y-5">
            <div data-testid="rating-google" className="flex items-center gap-3">
              <div className="flex items-center gap-1 text-[#eab308]">
                <Star size={18} fill="#eab308" strokeWidth={0} />
                <span className="font-display font-bold text-xl text-[#f5f5f0]">
                  {restaurant.ratings.google.score}
                </span>
              </div>
              <span className="text-sm text-[#a3a3a3]">
                Google · {restaurant.ratings.google.count} Bewertungen
              </span>
            </div>
            <div data-testid="rating-lieferando" className="flex items-center gap-3">
              <div className="flex items-center gap-1 text-[#eab308]">
                <Star size={18} fill="#eab308" strokeWidth={0} />
                <span className="font-display font-bold text-xl text-[#f5f5f0]">
                  {restaurant.ratings.lieferando.score}
                </span>
              </div>
              <span className="text-sm text-[#a3a3a3]">
                Lieferando · {restaurant.ratings.lieferando.count} Bewertungen
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-0 right-0 z-10 mx-auto max-w-7xl px-6 md:px-10 hidden md:flex items-center gap-6 text-sm text-[#a3a3a3]">
        <span className="flex items-center gap-2"><MapPin size={16} className="text-[#e05d36]" /> {restaurant.address}</span>
        <span className="flex items-center gap-2"><Clock size={16} className="text-[#e05d36]" /> {restaurant.delivery}</span>
      </div>
    </section>
  );
}
